// /!\ This file will not be transpiled to ES5 for old browsers, keep it as ES5

/**
 * A naive MutationObserver
 * It use the native MutationObserver if supported or naive fallback (for IE10) based on setInterval
 * Use it only if you want to watch a live HTMLCollection or NodeList and loop over it after each mutations
 * If you need a real MutationObserver (care about DOM changes), use a polyfill like https://github.com/megawac/MutationObserver.js or https://github.com/webcomponents/webcomponentsjs/blob/52fe0c3247f0d33a7893a5a224569ffccab3efeb/src/MutationObserver/MutationObserver.js
 */
var defaultTimeout = 150;
var records = Object.freeze([]);

// Detect native mutation observer with toString of it constructor
var nativeMutationObserver = typeof window.MutationObserver === "function" && Function.prototype.toString.call(MutationObserver).indexOf("[native code]") >= 0 && window.MutationObserver;
// Use native mutation observer or setInterval as fallback (don't use costly polyfill)
// Support an additional param, shouldn't be a problem with the native implementation, which ignore it
export default nativeMutationObserver || function (callback, timeout) {
  timeout = timeout === undefined ? defaultTimeout : timeout;
  var id = null;
  return {
    observe: function(){
      // Has already a set interval
      if(id){
        return;
      }

      id = setInterval(callback.bind(null, records, this), timeout);
    },
    disconnect: function(){
      clearInterval(id);
      id = null;
    },
    takeRecords: function(){
      return records;
    }
  }
};
